import * as actionTypes from './actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_ACTIVE_HOOK:
      return {
        ...state,
        activeHook: action.hook,
      };
    default:
      return state;
  }
};

export const getActiveHook = state => state.activeHook;
